<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="$router.back()">
                        <img src="@/assets/common/hd_prev_btn.png" alt="" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <p class="page_title">간편 회원가입</p>
                <form id="user_form">
                    <div class="input_wrap">
                        <div class="input_box input_verf_box">
                            <span class="ico"><img src="@/assets/user/form_ico1.png" alt="" /></span>
                            <div class="email_box">
                                <input type="text" v-model="state.email" placeholder="이메일" @input="emailEdit" />
                                <span>@</span>
                                <input type="text" :style="!state.showDomain ? 'display:block' : 'display:none'"
                                    v-model="state.directDomain" placeholder="직접입력" class="direct_email"
                                    @input="emailEdit" />
                                <button type="button" :style="!state.showDomain ? 'display:block' : 'display:none'"
                                    class="email_change_btn" @click="emailChangeBtn"></button>
                                <select v-if="state.showDomain" v-model="state.domain" id="email_select"
                                    @change="selectDomain">
                                    <option value="naver.com">naver.com</option>
                                    <option value="gmail.com">gmail.com</option>
                                    <option value="hanmail.net">hanmail.net</option>
                                    <option value="kakao.com">kakao.com</option>
                                    <option value="직접입력">직접입력</option>
                                </select>
                                <button type="button" class="email_chk_btn" @click="existEmail">중복확인</button>
                            </div>
                        </div>
                        <p class="verf_txt" :class="check.exist ? 'fail' : 'success'" v-if="check.existEmail"
                            style="display: block">
                            {{ state.excistText }}
                        </p>
                        <div class="input_box">
                            <span class="ico"><img src="@/assets/user/form_ico4.png" alt="" /></span>
                            <div class="info_input_box">
                                <input type="tel" @input="phonePaternCheck" v-model="state.phone" placeholder="전화번호" />
                                <span class="input_info">숫자만 입력</span>
                            </div>
                        </div>
                        <p class="verf_txt fail" v-if="check.phone" style="display: block">
                            전화번호가 정확한지 확인해 주세요.
                        </p>
                    </div>
                    <button id="submit_btn" @click="checkForm">
                        <img src="@/assets/common/write_ico.png" />회원가입
                    </button>
                    <p class="check_form_info">VAS 설문 진행을 위한 간편 회원가입입니다.</p>
                </form>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"> </ModalComponent>
</template>

<script lang="ts" config>
import { reactive, router, imgRender, apiService, res, ModalComponent, onMounted, userStore } from "@/BaseComponent";

export default {
    components: {
        ModalComponent,
    },
    setup() {
        const user = userStore();
        const state = reactive({
            fcmToken: "string" as string,
            imgUrl: "" as string,
            profileImg: null as any,
            email: "" as string,
            directDomain: "" as string,
            domain: "naver.com" as string,
            pw: "" as string,
            pw_check: "" as string,
            name: "" as string,
            phone: "" as string,
            birthday: "" as string,
            weigth: "" as string,
            height: "" as string,
            dept: "" as string,
            gender: "" as string,
            excistText: "" as string,
            checkInfo: false as boolean,
            showDomain: true as boolean,
            isModalOpen: false as boolean,
            isProfileImg: false as boolean,
        });

        const check = reactive({
            select: false as boolean,
            phone: false as boolean,
            passwordPetern: false as boolean,
            samePassword: false as boolean,
            existEmail: false as boolean,
            exist: true as boolean,
        });

        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
        });

        onMounted(() => {
            if (user.token) {
                router.replace("/");
            }
            getFcmToken();
        });
        const getFcmToken = () => {
            if (window.Android && window.Android.getFirebaseToken)
                state.fcmToken = window.Android.getFirebaseToken();
        };

        const phonePaternCheck = () => {
            const phoneNumberPattern1 = /^\d{10,11}$/;
            if (phoneNumberPattern1.test(state.phone)) {
                check.phone = false;
            } else {
                check.phone = true;
            }
        };
        const selectDomain = () => {
            if (state.domain === "직접입력") {
                state.showDomain = false;
                state.directDomain = "";
            }
        };

        const emailChangeBtn = () => {
            state.showDomain = true;
            state.domain = "naver.com";
            state.directDomain = "";
        };

        const checkForm = (e: any) => {
            e.preventDefault();
            if (state.email !== "" && state.domain !== "" && state.phone !== "") {
                if (state.excistText == "사용 가능한 이메일입니다.") {
                    if (!check.phone) {
                        save();
                    } else {
                        modal.content = "전화번호 형식을 확인해주세요";
                        modal.cancel = "확인";
                        modal.confirm = "";
                        state.isModalOpen = true;
                    }
                } else {
                    modal.content = "이메일 중복확인을 해주세요";
                    modal.cancel = "확인";
                    modal.confirm = "";
                    state.isModalOpen = true;
                }
            } else {
                modal.content = "ID(email), 전화번호는 필수 입력값입니다.";
                modal.cancel = "확인";
                modal.confirm = "";
                state.isModalOpen = true;
            }
        };

        //api 호출
        const save = async () => {
            const param: FormData = new FormData();
            let email = "";
            if (state.domain === "직접입력") {
                email = `${state.email}@${state.directDomain}`;
            } else {
                email = `${state.email}@${state.domain}`;
            }
            param.append("token", state.fcmToken);
            param.append("id", email);
            param.append("phone", state.phone);
            const response = await apiService.base.joinSample(param);
            if (response.returnCode === 0) {
                modal.content = "회원가입이 완료되었습니다. 로그인해주세요";
                modal.confirm = "확인";
                modal.cancel = "";
                state.isModalOpen = true;
            } else {
                console.error(response.description);
                modal.content = response.description;
                modal.confirm = "";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const existEmail = async () => {
            let email = "";
            if (state.domain === "직접입력") {
                email = `${state.email}@${state.directDomain}`;
            } else {
                email = `${state.email}@${state.domain}`;
            }

            let res: res = await apiService.base.existId(email);
            if (state.email !== "" && state.domain !== "" || state.directDomain !== "") {
                if (res.returnCode === 0) {
                    check.existEmail = true;
                    check.exist = false;
                    state.excistText = "사용 가능한 이메일입니다.";
                } else {
                    console.error(res.description);
                    check.existEmail = true;
                    check.exist = true;
                    state.excistText = "이미 등록된 이메일입니다.";
                }
            } else {
                check.existEmail = true;
                check.exist = true;
                state.excistText = "이메일 형식을 확인해주세요.";
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.content) {
                    case "회원가입이 완료되었습니다. 로그인해주세요":
                        router.back();
                        break;

                    default:
                        break;
                }
            }
        };

        const emailEdit = () => {
            check.existEmail = true;
            check.exist = true;
            state.excistText = "이메일 중복확인을 해주세요";
        };
        return {
            state,
            modal,
            check,
            router,
            save,
            existEmail,
            selectDomain,
            emailChangeBtn,
            phonePaternCheck,
            checkForm,
            modalClose,
            emailEdit,
        };
    },
};
</script>
